const environment = {
        BASE_URL: "https://loopo.circulare.es/",
        VITE_API_URL:"https://appformularios-dev.azurewebsites.net",
        VITE_CRIPTO:"as54casd$_sasu23!",
        VITE_FINHAVA: 'https://connect.skyvia.com/o011r8o0',
        VITE_FINHAVA_USER: 'API_Finhava_User',
        VITE_FINHAVA_PASSWORD: `9"9V]9]_Wh=0)D'i~Yd56Qxq`,
        VITE_FINHAVA_AUTHORIZATION: "Basic QVBJX0ZpbmhhdmFfVXNlcjo5IjlWXTldX1doPTApRCdpfllkNTZReHE="
    }
export default environment;